import React from 'react';
import {
  zoomMotions,
  panMotions,
  circularMotions,
  randomMotions,
} from '@monorepo/remotion-ninja';
import { MotionPreview } from './motion-preview';
import { MotionType } from '@monorepo/types';
import { useTranslation } from 'react-i18next';

interface Props {
  imageUrl: string;
  selectedMotion?: MotionType;
  onSelect?: (motion: MotionType) => void;
}

export const MotionGroupList: React.FC<Props> = ({
  imageUrl,
  selectedMotion,
  onSelect,
}) => {
  const { t } = useTranslation();
  const motionGroups = [
    { title: t('videoEditor.motionGroups.zoom'), motions: zoomMotions },
    { title: t('videoEditor.motionGroups.pan'), motions: panMotions },
    {
      title: t('videoEditor.motionGroups.circular'),
      motions: circularMotions,
    },
    { title: t('videoEditor.motionGroups.random'), motions: randomMotions },
  ];

  return (
    <div>
      {motionGroups.map((group) => (
        <div key={group.title} style={{ marginBottom: '20px' }}>
          <h2
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
              marginBottom: '10px',
            }}
          >
            {group.title}
          </h2>
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            {Object.keys(group.motions).map((motion) => {
              const isSelected = selectedMotion === motion;
              return (
                <div
                  key={motion}
                  onClick={() => onSelect?.(motion as MotionType)}
                  style={{
                    width: '150px',
                    height: '250px',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    outline: isSelected ? '5px solid #1890ff' : 'none',
                  }}
                >
                  <MotionPreview
                    motion={group.motions[motion]}
                    progress={0.5}
                    imageUrl={imageUrl}
                    name={motion}
                  />
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
